export default "__VITE_ASSET__5K89NF0I__"